import {AppAction} from '../../../store/interfaces/IAppState';
import {AppEnsightenEventType} from './app-ensighten-event-type.model';
import {EnsightenEventType} from './ensighten-event-type.model';
export class ApplicationEnsightenEvent {
  private reduxEvents: Map<AppAction, boolean>;
  constructor(private _type: AppEnsightenEventType, appActions: Array<AppAction>, private _ensightenEventWhenReady?: EnsightenEventType) {
    this.reduxEvents = new Map<AppAction, boolean>();
    appActions.forEach((appAction) => {
      this.reduxEvents.set(appAction, true);
    });
  }
  get type(): AppEnsightenEventType {
    return this._type;
  }
  get ensightenEventWhenReady(): EnsightenEventType {
    return this._ensightenEventWhenReady;
  }
  appActionReady(appAction: AppAction) {
    if (this.reduxEvents.get(appAction)) {
      this.reduxEvents.set(appAction, false);
    }
  }
  isReady() {
    return !!!(Array.from(this.reduxEvents.values()).find(element => element));
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/model/ensighten/application-event.model.ts